import context from '@truckdown/systems';
import accountComponents from '@truckdown/components-accounts';

import './Components';
import './Styles/main.less';

accountComponents.registerPrerequisites(context);

context.initialize().then(() => {
    console.log('System initialized');
});